import React, { Component } from 'react';
import{ Container, Row} from 'reactstrap';
import { HomeButton } from './HomeButton'
import ricercaCliente from '../img/icona ricerca clienti.png'
import nuovoCliente from '../img/icona nuovo cliente.png'
import nuovoOrdine from '../img/icona nuovo ordine.png'
import nuovoVersamento from '../img/icona nuovo versamento.png'
import statistiche from '../img/icona statistiche.png'
import listinoPrezzi from '../img/icona listino prezzi.png'
import storicoOrdini from '../img/icona storico ordini.png'
import storicoVersamenti from '../img/icona storico versamenti.png'
import catalogo from '../img/icona catalogo.png'
import FattureScadute from '../img/icona fatture scadute.png'
//import Salvadanaio from '../img/Salvadanaio.png'

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <Container fluid> 
        <Row style={{width: '100%', margin: '0px'}}>
          <HomeButton path="/ricercaCliente" history={this.props.history} image={ricercaCliente} name="RICERCA CLIENTE" classes={"col-md-3 col-6"} />
          <HomeButton path="/fattureScadute" history={this.props.history} image={FattureScadute} name="FATTURE SCADUTE" classes={"col-md-3 col-6"}></HomeButton>
          <HomeButton path="/nuovoCliente" history={this.props.history} image={nuovoCliente} name="NUOVO CLIENTE" classes={"col-md-3 col-6"}></HomeButton>
          <HomeButton path="/nuovoOrdine" history={this.props.history} image={nuovoOrdine} name="NUOVO ORDINE" classes={"col-md-3 col-6"}></HomeButton>
          <HomeButton path="/nuovoVersamento" history={this.props.history} image={nuovoVersamento} name="NUOVO VERSAMENTO" classes={"col-md-3 col-6"}></HomeButton>
          <HomeButton path="/statistiche" history={this.props.history} image={statistiche} name="STATISTICHE" classes={"col-md-3 col-6"}></HomeButton>
          <HomeButton path="/listinoPrezzi" history={this.props.history} image={listinoPrezzi} name="LISTINO PREZZI" classes={"col-md-3 col-6"}></HomeButton>
          <HomeButton path="/storicoOrdine" history={this.props.history} image={storicoOrdini} name="STORICO ORDINI" classes={"col-md-3 col-6"}></HomeButton>
          <HomeButton path="/storicoVersamenti" history={this.props.history} image={storicoVersamenti} name="STORICO VERSAMENTI" classes={"col-md-3 col-6"}></HomeButton>
          {/*<HomeButton path="/Salvadanaio" history={this.props.history} image={Salvadanaio} name="SALVADANAIO" classes={"col-md-3 col-6"}></HomeButton>*/}
          {sessionStorage.getItem('selectedRole') === 'Controller' ? <HomeButton path="/Catalogo" history={this.props.history} image={catalogo} name="CATALOGO" classes={"col-md-3 col-6"}></HomeButton> : null}
        </Row>
      </Container>
     
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js